import { ISession } from '../../types';

export const getSessionsForSpeaker = (spkId: string, sessions: ISession[]): ISession[] => {
  const res = sessions.filter((sess: ISession) => sess.speakersId?.includes(spkId));
  return res;
};
